<div *ngIf="loader()">
  <img src="https://services.tiscoinsure.com/contents/images/Header-TISCO-Insure.png" style="width: 100%;">
  <section class="uk-section uk-position-relative" uk-height-viewport style="padding-top: 0px;">
    
    <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
      <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
        <div class="uk-container uk-container-small">
          <div class="uk-card uk uk-card-body">
            <div>
              <label class="uk-form-label" style="font-size: 0.7rem !important; font-weight: bold;">แบ่งชำระรายเดือน<span style="font-size: 1.7rem !important; float: right; margin-bottom: 10px;">{{installment.length}} เดือน</span></label>
              <br/>
            </div>
            <div class="hline"></div>
            <div *ngFor="let x of installment(); let i = index;">
              <div *ngIf="i == 0">
                <div>         
                  <label class="uk-form-label" style="font-size: 0.8rem !important; font-weight: bold; word-wrap: break-word;">ยอดชำระต่อเดือน<span style="float: right; font-weight: bold;">{{numberWithCommas(x.amount)}} บาท</span></label>
                </div>
                <div>         
                  <label class="uk-form-label" style="font-size: 0.8rem !important; font-weight: bold; word-wrap: break-word;">ยอดชำระเงินงวดแรก<span style="float: right; font-weight: bold;">{{x.date}}</span></label>
                </div>
              </div>
              <div *ngIf="i != 0">
                <div class="hline"></div>
                <div>         
                  <label class="uk-form-label" style="font-size: 0.8rem !important; font-weight: bold; word-wrap: break-word;">ชำระงวดที่ {{i+1}} - {{x.date}}<span style="float: right; font-weight: bold;">{{numberWithCommas(x.amount)}} บาท</span></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<app-loader *ngIf="!loader()"></app-loader>